// extracted by mini-css-extract-plugin
module.exports = {"section":"UserDetails_section__3-avA","pill":"UserDetails_pill__2-AMX"};